__webpack_require__.p = "/intercom-fix-stg/referrals-hub/";